import { render, staticRenderFns } from "./FormRow.vue?vue&type=template&id=f9c1b562&scoped=true&"
import script from "./FormRow.vue?vue&type=script&lang=js&"
export * from "./FormRow.vue?vue&type=script&lang=js&"
import style0 from "./FormRow.vue?vue&type=style&index=0&id=f9c1b562&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c1b562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSwitch,VTooltip})
